import MyAccountChangePlanPage from './MyAccountChangePlanPage'

export default MyAccountChangePlanPage
// eslint-disable-next-line import/export
export * from './MyAccountChangePlanPage'
